<template>
	<div>
		<modal class="new-modal-default"  :name="modal_name"  transition="nice-modal-fade" :width="1300" :height="510" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
			<div class="v-modal-content" style="background-color: #ffffff !important;">
				<div class="v-modal-header modal-height" >
					<span class="v-modal-dialog-title v-modal-title fw-600 py-3 ml-auto mr-auto"
						style="color: #fff !important;letter-spacing:1px;">Deals details</span>
					<button type="button" class="pointer" style="background-color: #00448b !important;outline:none;"
						aria-label="Close" @click="hideListDealsModal()">
						<span aria-hidden="true">
							<i class="icon icon-close" style="color:white;margin:10px 10px 0 0;"></i>
						</span>
					</button>
				</div>
				<div class="v-modal-body" style="overflow:auto;">
					<div class="row filter-tab" :class="{'pointer-event':display_filters}">
						<div class="d-flex">
							<div class='slant-tabs' :class="{'activeTab':active_tab == 'achieved_deals','new-blue':active_tab == 'achieved_deals'}" @click="switchTabs('achieved_deals')">
								<span :class="{'topnavbar':active_tab == 'achieved_deals'}">Achieved Deals</span>
							</div>
							<div class="slant-tabs ml-2" :class="{'activeTab':active_tab == 'deals_pipeline','new-blue':active_tab == 'deals_pipeline'}" @click="switchTabs('deals_pipeline')">
								<span :class="{'topnavbar':active_tab == 'deals_pipeline'}">Deals in Pipeline</span>
							</div>
							<div class="slant-tabs ml-2" :class="{'activeTab':active_tab == 'lost_deals','new-blue':active_tab == 'lost_deals'}" @click="switchTabs('lost_deals')">
								<span :class="{'topnavbar':active_tab == 'lost_deals'}">Lost Deals</span>
							</div>
						</div>
						<div class="d-flex mr-6">
						<button class="btn btn-new-primary btn-wide list-dealbtn" @click="showFilters()"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;"> Filter</button>
						</div>
					</div>
					<!-- Table Section -->
					<div class="tab-tabledata">
						<table class="team-ldeal-table table-responsive w-100">
							<thead>
								<tr>
									<th class="w-1 whiteSpace">Deal Name</th>
									<th>Deal Owner</th>
									<th v-if="loggedInUser.user_role == 'sales_manager'">Team Lead</th>
									<th>Pipeline Name</th>
									<th>Deal Price({{currency}})</th>
									<th v-if="status != 'lost'">Predicted Probability</th>
								</tr>
							</thead>
							<tbody>
								<tr v-if="deals.length == 0">
									<td colspan="5" class="fw-600 text-center">No Data</td>
								</tr>
								<tr v-else v-for="(list,index) in deals" :key="index">
									<td style="color:#0475f3;" class="pointer" @click="viewDeals(list.deal_id)">{{list.deal_name}}</td>
									<td style="color:#0475f3;" class="pointer" @click="displayDeals(list)">{{list.deal_owner}}</td>
									<td v-if="loggedInUser.user_role == 'sales_manager'">{{list.team_lead}}</td>
									<td>{{list.pipeline_name}}</td>
									<td>{{list.transaction_value}}</td>
									<td v-if="status != 'lost'">{{formatPrice(list.predicted_probability)}}</td>
								</tr>
							</tbody>
						</table>
						<div class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
							<multiselect v-if="deals.length" class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow" :options="pageLimit" :close-on-select="true" v-model.number="limit" :max-height="200" @close="loadDeals" open-direction="top" :show-labels="false" placeholder="" style="width: 4.2em !important;padding-right: 10px!important;">
							</multiselect>
							<span class="page-info pr-2 pl-6 fw-500" style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
							<button @click="firstPage()" class="mt-1 pointer pagination-list">
								<el-tooltip class="item" effect="dark" content="First Page" placement="top">
									<i class="icon-chevron-double-left"></i>
								</el-tooltip>
							</button>
							<button @click="previousPage()" class="pagination-list mt-1 ml-2 pointer">
								<el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
									<i class="icon icon-chevron-left"></i>
								</el-tooltip>
							</button>
							<span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
							<button @click="nextPage()" class="pagination-list mt-1 mr-2 pointer">
								<el-tooltip class="item" effect="dark" content="Next Page" placement="top">
									<i class="icon icon-chevron-right"></i>
								</el-tooltip>
							</button>
							<button @click="lastPage()" class="mt-1 pointer pagination-list">
								<el-tooltip class="item" effect="dark" content="Last Page" placement="top">
									<i class="icon-chevron-double-right"></i>
								</el-tooltip>
							</button>
						</div>
					</div>
				</div>
				<div class="v-modal-footer m-auto p-4">
					<button class="btn btn-des-small ml-2 mr-2"
						style="color: #fff; background: #0475f3; border: 1px solid #0475f3"
						@click="hideListDealsModal()">Close</button>
				</div>
			</div>
		</modal>
		<div v-show="display_filters" class="scm-filters fadeInDown castdeal-filters" :class="{'fadeInUp':hide_filters == true}">
            <modal-filterData :sales_forecast_details="sales_forecast_details" @UpdateByFilter="UpdateByFilter" :status="status" @hideFilters="hideFilters"></modal-filterData>
        </div>
	</div>
</template>

<script>
import ModalFilterData from './ModalFilterData';
import salesforecast from "../mixins/salesforecast";
import { EventBus } from '../eventBus/nav-bar-event';
export default {
    props: ["modal_name","sales_forecast_details","selected_deal"],
	components: {
		ModalFilterData,
	},
	data() {
		return {
			active_tab: 'achieved_deals',
            achieved_deals: true,
            deals_pipeline: false,
            lost_deals :false,
			hide_filters: false,
			display_filters: false,
			status: this.selected_deal,
			filter_json:{
				deal_name: [],
				deal_owner_name: []
			},
			ajaxCallInProgress: false,
			search_key: "",
			skip_temp:0,
			temp_total:0,
			limit: 10,
			count: 0,
			pageLimit: [],
			skip:0,
			start: 0,
			end: 0,
			total: 0,
			deals: [],
			display_deals: false,
			currency:''
		}
	},
	mixins:[salesforecast],
	methods: {
		formatPrice(value) {
			let val = (value / 1).toFixed(2).replace(",", ".");
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
		viewDeals(id){
			this.$router.push({
				name: "DealDetails",
				path: '/deals/dealdetails',
				params: {
					id: id,
				}
			});
		},
		hideListDealsModal() {
			this.$modal.hide(this.modal_name);
			this.$emit("hideDeals")
		},
		switchTabs(obj){
            if(obj == 'achieved_deals'){
                this.active_tab = 'achieved_deals'
            	this.achieved_deals= true
            	this.deals_pipeline= false
				this.lost_deals = false
				this.status = "won"
				this.loadDeals()
            }
            else if(obj == 'deals_pipeline'){
                this.active_tab = 'deals_pipeline'
            	this.achieved_deals= false
            	this.deals_pipeline= true
            	this.lost_deals = false
				this.status = "active"
				this.loadDeals()
            }
            else if(obj == 'lost_deals'){
                this.active_tab = 'lost_deals'
            	this.achieved_deals= false
            	this.deals_pipeline= false
            	this.lost_deals = true
				this.status = "lost"
				this.loadDeals()
            }
        },
		showFilters(){
            if(this.display_filters) {
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters() {
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
		},
		previousPage() {
			this.temp_total = 0
			this.skip_temp = 0
			if (this.skip == 0) {
				return;
			}
			this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
			this.loadDeals();
		},
		nextPage() {
			this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
			if (this.skip_temp >= this.total) {
				return;
			}
			this.skip = this.skip_temp;
			this.loadDeals();
		},
		firstPage(){
			this.temp_total = 0
			this.skip = 0
			this.limit = this.limit
			this.loadDeals();
		},
		lastPage() {
			this.skip_temp = 0
			this.skip = 0
			this.temp_total = this.total
			let no_of_pages = Math.ceil(this.total/this.limit)
			this.skip_temp = (no_of_pages * this.limit) - this.limit
			if (this.skip_temp >= this.total) {
				return;
			}
			this.skip = this.skip_temp
			this.loadDeals();
		},
		async loadDeals(){
			this.ajaxCallInProgress = true
			let params = {
				skip: 0,
				limit: this.limit,
				sales_forecast_id: this.$route.params.id,
				product_id: this.sales_forecast_details.product_id,
				status: this.status,
				filter_json: this.filter_json
			}
			let response = await this.listSalesForeCastDeals(params)
			this.deals = response.response
			this.total = response.count;
			this.ajaxCallInProgress = false
		},
		removeChips(value,key){
            let params = {
                value:value,
                key:key
            }
            EventBus.$emit('removechip',params)
        },
        removeAllChips(){
            this.filter_json = {
                deal_name: [],
                deal_owner_name: [],
            }
            EventBus.$emit('removeAllchip')
			this.loadDeals()
        },
        UpdateByFilter(params){
            this.skip = 0
            this.limit = 10
            this.filter_json = {
                deal_name:params.value.deal_name,
                deal_owner_name:params.value.deal_owner
            }
			this.loadDeals()
        },
		displayDeals(list){
			let data = {
				selected_deal: this.selected_deal,
				list: list
			}
				localStorage.setItem('deal_details',JSON.stringify(data))
				this.$router.push("/salesForeCast/view_deals/"+this.$route.params.id)
		}
	},
	mounted(){
		this.currency = this.loggedInUser.currency.symbol;
		this.loadDeals()
		for (let i = 1; i <= 50; i++) {
			this.pageLimit.push(i);
		}
		if(this.status == 'won'){
			this.active_tab = 'achieved_deals'
		}
		else if(this.status == 'active'){
			this.active_tab = "deals_pipeline"
		}
		else if(this.status == 'lost'){
			this.active_tab = "lost_deals"
		}
	},
	computed: {
		getSkipCount() {
			if(this.total == 0) {
				return 0
			} else {
				let skip_count = this.skip>this.total?this.total:this.skip+1;
				return skip_count;
			}
		},
		loggedInUser() {
            return this.$store.state.loggedInUser;
        }
	}
}
</script>

<style scoped>
	.list-dealbtn{
		background-color: #206ad3;
	}
	.row-filter{
		justify-content: flex-end;
		padding-right: 30px;
	}
	.team-ldeal-table thead tr th {
		background: #005dae;
		color: #fff;
		padding: 12px 61px;
		font-size: 13px;
		font-weight: 400;
		white-space: nowrap;
	}
	.team-ldeal-table tbody tr td {
		background: #fff;
		padding: 10px 61px;
		font-size: 13px;
		font-weight: 400;
		border-bottom: 1px solid #f2f3f5;
		white-space: nowrap;
	}
	.filter-tab{
		justify-content: space-between;
	}
	.tab-tabledata{
		border: 1px solid #707070;
		border-radius: 5px;
		margin: 5px 10px 5px 15px;
	}
	.castdeal-filters{
        height: 160px !important;
    	background: #e6ecff;
    	overflow: inherit !important;
    	right: 227px;
    	top: 230px;
    }
	.page-alignment{
		justify-content: flex-end;
    	margin-right: 4px;
	}
	.selected-deal{
		border-bottom: solid 2px #00448b !important;
	}
	.selected-deal{
		border-bottom: solid 2px transparent !important;
	}
	.pointer-event{
		pointer-events: none !important;
		background: #fff !important;
	}
	.topnavbar{
		border-bottom: 3px solid #226bd3;
	}
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/ListDeals.vue